"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGeneratePdfReportDialog = void 0;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const PdfClient_1 = require("@juvare/platform-sdk-js/PdfClient");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
function useGeneratePdfReportDialog() {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (pdfRequest, onPreloadData, downloadFileName) => {
        var _a;
        if (window.location.hostname !== 'localhost') {
            const timeZone = (_a = pdfRequest.timeZone) !== null && _a !== void 0 ? _a : Intl.DateTimeFormat().resolvedOptions().timeZone;
            (0, DialogHelper_1.showProgressDialog)({
                title: t('pdfReports.generatingPdfReport'),
                callback: (done) => {
                    const processPdfRequest = (request) => {
                        (0, PdfClient_1.requestAndPollReport)(request)
                            .then(({ jobId, status, errorMessage }) => {
                            done();
                            if (status === 'Completed') {
                                (0, DialogHelper_1.showConfirmDialog)({
                                    title: t('pdfReports.confirmDownloadPdfReport'),
                                    confirmLabel: t('common.download'),
                                    onConfirm: () => (0, PdfClient_1.downloadReport)(jobId, downloadFileName),
                                });
                            }
                            else {
                                (0, DialogHelper_1.handleErrorDialog)(errorMessage);
                            }
                        })
                            .catch((error) => {
                            done();
                            (0, DialogHelper_1.handleErrorDialog)(error);
                        });
                    };
                    if (onPreloadData) {
                        onPreloadData
                            .then((components) => {
                            processPdfRequest({ components: [...pdfRequest.components, ...components], timeZone: timeZone });
                        })
                            .catch((error) => {
                            done();
                            (0, DialogHelper_1.handleErrorDialog)(error);
                        });
                    }
                    else {
                        processPdfRequest(Object.assign(Object.assign({}, pdfRequest), { timeZone: timeZone }));
                    }
                },
            });
        }
        else {
            (0, DialogHelper_1.showErrorDialog)({
                title: t('pdfReports.pdfGenerationNotSupportedLocalhost'),
            });
        }
    };
}
exports.useGeneratePdfReportDialog = useGeneratePdfReportDialog;
